
















































































import Vue from 'vue'
import CreateLayout from '@/components/CreateLayout'
import LayoutPreview from '@/components/LayoutPreview'
import LeftSidebarLayout from '@/components/LeftSidebarLayout'
import { Table, TableColumn, Button } from 'element-ui'
import './LayoutManager.scss'
import defaultchatcss from '@/components/Widgets/Chat/defaultcss'
import defaultinstagramcss from '@/components/InstagramElement/defaultcss'
import defaultLivechatcss from '@/components/LiveChatElement/defaultcss'
import { Team } from '@/types/teams'
import {
  LayoutBox,
  Layout,
  LayoutBoxMap,
  SimplecgCSS,
  TweetCSS,
  CasterCSS,
  ChatCSS,
  InstagramCSS,
  LiveChatCSS,
  SceneTransition,
  TransitionType
} from '@/types/layouts'
import { KeyDict } from '@/types'
import { SceneContent } from '@/types/sceneContent'
// import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'
import BOX from '@/defaults/box'
import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'

interface LayoutTableItem {
  key: string,
  name: string,
  info: string,
  default: boolean,
  boxes: { [id: string]: LayoutBox },
  editable: boolean
}

export default Vue.extend({
  name: 'LayoutManager',
  computed: {
    canReadLayouts (): boolean {
      return this.$can(AbilityAction.Read, AbilitySubject.Layout)
    },
    canCreateLayouts () : boolean {
      return this.$can(AbilityAction.Create, AbilitySubject.Layout)
    },
    canEditLayouts () : boolean {
      return this.$can(AbilityAction.Edit, AbilitySubject.Layout)
    },
    canDeleteLayouts () : boolean {
      return this.$can(AbilityAction.Delete, AbilitySubject.Layout)
    },
    teamCheck () : boolean | null {
      return this.$store.direct.state.user.teamCheck
    },
    teamLayouts (): Layout[] {
      return this.$store.direct.state.team.teamLayouts
    },
    activeTeam (): string {
      return this.$store.direct.state.team.activeTeam
    },
    team (): Team {
      return this.$store.direct.state.team.team
    },
    sortedTeamLayouts (): Layout[] {
      const arr: Layout[] = (this.teamLayouts || []).slice()
      return arr.sort((layouta, layoutb) => layouta.name.localeCompare(layoutb.name))
    },
    convertedLayouts (): LayoutTableItem[] {
      const arr: LayoutTableItem[] = []
      if (this.teamLayouts === undefined) {
        return arr
      }
      this.teamLayouts.forEach(element => {
        if (this.team !== undefined) {
          arr.push({
            key: element.id || 'unknown',
            name: element.name,
            info: element.info,
            default: this.team.default_layout === element.id,
            boxes: element.boxes,
            editable: element.editable !== undefined ? element.editable : true
          })
        }
      })
      return arr.sort((layouta, layoutb) => layouta.name.localeCompare(layoutb.name))
    }
  },
  data: () => ({
    showCreateLayout: false,
    importing: false
  }),
  methods: {
    editLayout (layoutId: string) {
      const route = this.$router.resolve({ name: 'layouteditor', params: { id: layoutId } })
      window.location.href = route.href
    },
    createLayout () {
      this.showCreateLayout = true
      this.importing = false
    },
    importLayout () {
      this.showCreateLayout = true
      this.importing = true
    },
    newLayout (layout: Layout) {
      this.showCreateLayout = false

      let baseBoxes: LayoutBoxMap = {
        background: BOX.background,
        slates: BOX.slates
      }
      let transition: SceneTransition = {
        type: TransitionType.NONE,
        actions: []
      }
      let castercss: CasterCSS = new CasterCSS()
      let clips = {
        automute: false
      }
      let tweetcss = new TweetCSS()
      let simplecgcss: KeyDict<SimplecgCSS> = {}
      let chatcss: ChatCSS = defaultchatcss
      let instagramcss: InstagramCSS = defaultinstagramcss
      let livechatcss: LiveChatCSS = defaultLivechatcss
      let editable = true
      //let info = ''
      let contents: KeyDict<SceneContent> = {}

      if (layout.existingLayout) {

        const transitionBox = { ...baseBoxes.transition }
        baseBoxes = layout.existingLayout.boxes
        if (!baseBoxes.transition) baseBoxes.transition = transitionBox

        // @ts-ignore // FIXME
        if (layout.existingLayout.transition) transition = layout.existingLayout.transition

        castercss = layout.existingLayout.castercss
        clips = layout.existingLayout.clips
        if (layout.existingLayout.editable !== undefined) {
          editable = layout.existingLayout.editable
        }
        /* if (layout.existingLayout.info) {
          info = layout.existingLayout.info
        } */ //Wouldn't get copied over, now that Description is a form field
        if (layout.existingLayout.simplecgcss) {
          simplecgcss = layout.existingLayout.simplecgcss
        }
        if (layout.existingLayout.tweetcss) {
          tweetcss = layout.existingLayout.tweetcss
        }
        if (layout.existingLayout.chatcss) {
          chatcss = layout.existingLayout.chatcss
        }
        if (layout.existingLayout.instagramcss) {
          instagramcss = layout.existingLayout.instagramcss
        }
        if (layout.existingLayout.livechatcss) {
          livechatcss = layout.existingLayout.livechatcss
        }
        if (layout.existingLayout.contents) {
          contents = layout.existingLayout.contents
        }
      }
      const layoutData: Layout = {
        name: layout.name,
        info: layout.info,
        team_id: this.activeTeam,
        boxes: baseBoxes,
        contents: contents,
        transition,
        castercss,
        clips,
        editable,
        tweetcss,
        chatcss,
        simplecgcss,
        instagramcss,
        livechatcss
      }

      this.$store.direct.dispatch.layouts.addLayout(JSON.parse(JSON.stringify(layoutData)))
        .then((doc) => {
          if (doc && doc.id) {
            this.editLayout(doc.id)
          }
      }).catch(error => {
        console.error('New Layout error ', error)
      })
    },
    removeLayout (layoutId) {
      this.$confirm('Are you sure you want to delete this layout?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.$store.direct.dispatch.layouts.deleteLayout(layoutId)
      }).catch(() => {
      })
    },
    makeDefault (layoutId) {
      this.$store.direct.dispatch.team.setDefaultTeamLayout({ team_id: this.activeTeam, layout: layoutId })
    }
  },
  components: {
    CreateLayout,
    LeftSidebarLayout,
    LayoutPreview,
    'el-table': Table,
    'el-table-column': TableColumn,
    'el-button': Button
  }
})
